import { Component, Input, OnInit } from "@angular/core";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "src/app/_service/data.service";
import { FormatService } from "src/app/_service/format.service";

@Component({
    templateUrl: 'client-service.modal.html',
    styleUrls: ['client-service.modal.scss']
})
export class ClientServiceModal implements OnInit {
    faX = faX;

    @Input() public id: number = 0;
    @Input() public name: string = '';


    services: any = [];
    serviceCategories:any = {}

    constructor(
        public activeModal: NgbActiveModal, 
        public format: FormatService,
        private data: DataService
    ) {}

    ngOnInit(): void {
        this.loadServices();
    }


    async loadServices() {
        let result: any = await this.data.post('users/get-services', {passenger_id: this.id});
        if(!result.services) {
            this.data.showMessage(result.message ?? "Unable to load services", 'error');
            return;
        }

        this.services = result.services;
        this.serviceCategories = result.serviceCategories;
        result.user_services.map((element: any) => {
            let index = this.services.findIndex((el: any) => el.id == element.service_id)
            this.services[index].category = element.category;
            this.services[index].start_date = element.start_date;
            this.services[index].end_date = element.end_date;
            this.services[index].cost = this.format.currency(element.cost);
            this.services[index].unit = element.unit;
            this.services[index].checked = element.active == 1 ? true : false;
            if(!this.serviceCategories[element.service_id]) this.serviceCategories[element.service_id] = [];
        });
    }
    
    submitServices() {
        let includedServices: any = [];
        this.services.map((element: any) => {
            if(element.checked) {
                // Check if the property has been set
                if(!element.hasOwnProperty('cost')) element.cost = '0.00';
                else {
                    if(element.cost == '') element.cost = '0.00';
                    element.cost = this.format.stylizeNumber(element.cost);
                }
                if(!element.hasOwnProperty('unit')) element.unit = '';

                includedServices.push(element);
            }
        })

        
        this.data.post('users/update-services', { passenger_id: this.id, services: includedServices }).then((res: any) => {
            if (res.success) {
                this.data.showMessage("Client Services Updated", "success");
            }
            else {
                this.data.showMessage("Error - Client Services Not Updated", "error");
            }
            this.loadServices();
        })
    }
}